export const  GET_VIEW_HISTORY_REQUEST='viewHistoryReducer/GET_VIEW_HISTORY_REQUEST';
export const  GET_VIEW_HISTORY_SUCCESS='viewHistoryReducer/GET_VIEW_HISTORY_SUCCESS';
export const  GET_VIEW_HISTORY_FAILED='viewHistoryReducer/GET_VIEW_HISTORY_FAILED';